(() => {
  const hosts = new Set(['youtube.com', 'www.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com']);
  function identify(frame) {
    const source = frame.getAttribute('src');
    if (!source) return;
    let url;
    try { url = new URL(source, location.href); } catch { return; }
    if (!hosts.has(url.hostname) || !url.pathname.startsWith('/embed/')) return;
    const policy = 'strict-origin-when-cross-origin';
    const changedPolicy = frame.getAttribute('referrerpolicy') !== policy;
    const changedOrigin = url.searchParams.get('origin') !== location.origin;
    if (!changedPolicy && !changedOrigin) return;
    frame.setAttribute('referrerpolicy', policy);
    url.searchParams.set('origin', location.origin);
    frame.src = url.href;
  }
  function scan(root) {
    if (root.matches?.('iframe')) identify(root);
    root.querySelectorAll?.('iframe').forEach(identify);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') identify(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['src']});
})();
